import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Img/Nav_Icons/logo.png";
import { Footer } from ".././Footer/Footer";

import "./Error.css";

export const Error = () => {
  return (
    <main className="grid-container_2">
      <header className="error_header ">
        <div className="error_logo">
          <img src={Logo} alt="Site Logo - Error Page" />{" "}
        </div>
        <h2 className="gallery-item">404</h2>
        <div className="Section_heading-1"> Ahhh! Page not found</div>
        <Link className="error_back-link" to="/">
          back home
        </Link>
      </header>
      <Footer />
    </main>
  );
};
